import React, { memo, useCallback } from 'react'

import { func } from 'prop-types'

import WaitlistCard from 'Pods/Shared/Waitlist/WaitlistCard/WaitlistCard'
import applyAccessCodeResult from 'Pods/ThreeDStudio/Shared/Utils/applyAccessCodeResult'
import { setStudioAccessTier } from 'Pods/ThreeDStudio/Store/actions/subscription'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

import SubscriptionCard from '../SubscriptionCard/SubscriptionCard'

function JoinWaitlistBody({ onClose: handleClose }) {
  const handleJoined = useCallback((data) => {
    setStudioAccessTier(data.studioAccessTier || STUDIO_ACCESS_TIER.WAITLISTED)
  }, [])

  return (
    <div className="usage-modal__join-waitlist">
      <p className="usage-modal__headline cgt-body-md">
        You&apos;ve set everything up — now unlock generation to bring it to life.
      </p>

      <div className="usage-modal__cards">
        <WaitlistCard
          onJoined={handleJoined}
          onCodeApplied={applyAccessCodeResult}
          onClose={handleClose}
        />
        <SubscriptionCard onClose={handleClose} />
      </div>
    </div>
  )
}

JoinWaitlistBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(JoinWaitlistBody)
